import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { IUser } from '@shared/models/login.model';
import { environment } from 'src/environments/environment';
import {
  IChatConversation,
  IChatMember,
  IPreviousChats
} from '../../models/chat.model';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-messages-handler',
  templateUrl: './messages-handler.component.html',
  styleUrls: ['./messages-handler.component.scss']
})
export class MessagesHandlerComponent implements OnInit, OnChanges {
  @Input()
  public members: IChatMember[] = [];
  @Input()
  public recentContacts: IPreviousChats[] = []; // Only 5;
  @Input()
  public conversations: IChatConversation[] = [];

  public membersFiltered: IChatMember[] = [];
  public user: IUser;
  @Output()
  public selectMember: EventEmitter<IChatMember> = new EventEmitter<
    IChatMember
  >();
  @Output()
  public selectPreviosContact: EventEmitter<IPreviousChats> = new EventEmitter<
    IPreviousChats
  >();
  @Output()
  public selectConversation: EventEmitter<IChatConversation> = new EventEmitter<
    IChatConversation
  >();

  public searchtext: string;
  public environmentUrl = environment.resourcesUrl;
  constructor(private userService: UserService) {}

  ngOnInit() {
    this.user = this.userService.userInfo;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.members && changes.members.currentValue) {
      this.membersFiltered = this.members;
      this.searchtext = null;
    }
  }

  public validateText(): void {
    if (this.searchtext.length > 0) {
      this.membersFiltered = this.members.filter(member => {
        const name = `${member.name} ${member.last_name}`.toLowerCase();
        if (name.indexOf(this.searchtext.toLowerCase()) !== -1) {
          return member;
        }
      });
    } else {
      this.membersFiltered = this.members;
    }
  }
}
